import { isInViewport, isBelowViewport, isScrollAtEnd } from '@js/utilities/isInViewport';

export const viewportStickyElementsListener = () => {
    const viewportStickyElements = [
        ...document.querySelectorAll('.js-viewport-sticky-elements'),
    ].filter((el) => !el.dataset.viewportStickyElementsInitialized);

    const viewportMethodMap = {
        default: isInViewport,
        below: isBelowViewport,
    };

    viewportStickyElements.forEach((el) => {
        el.dataset.viewportStickyElementsInitialized = true;
    });

    window.addEventListener('scroll', () => {
        viewportStickyElements.forEach((viewportStickyElement) => {
            const correspondingStickyElements = document.querySelectorAll(
                `${viewportStickyElement.dataset.stickyElements}`
            );

            const method =
                viewportMethodMap[
                    viewportStickyElement.dataset.stickyElementsMethodType || 'default'
                ] || viewportMethodMap.default;

            correspondingStickyElements.forEach((el) => {
                if (method(viewportStickyElement)) {
                    el.classList.remove('is-active');
                } else {
                    el.classList.add('is-active');
                }
            });

            if (isScrollAtEnd()) {
                correspondingStickyElements.forEach((el) => {
                    el.classList.add('is-at-the-bottom');
                });
            } else {
                correspondingStickyElements.forEach((el) => {
                    el.classList.remove('is-at-the-bottom');
                });
            }
        });
    });
};
